// import { useEffect } from 'react';
// import auto_scaling from '@assets/img/aws_services/auto-scaling.svg';
import access_analyzer from '@assets/img/aws_services/access-analyzer.svg';
// import sagemaker from '@assets/img/aws_services/sagemaker.svg';
// import direct_connect from '@assets/img/aws_services/direct_connect.svg';
// import amazon_cloudfront from '@assets/img/aws_services/amazon-cloudfront.svg';
// import amazon_elasticcache from '@assets/img/aws_services/amazon-elasticcache.svg';
// import amazon_redshift from '@assets/img/aws_services/amazon-redshift.svg';
// import amazon_s3 from '@assets/img/aws_services/amazon-s3.svg';
// import amazon_ses from '@assets/img/aws_services/amazon-ses.svg';
// import amazon_sns from '@assets/img/aws_services/amazon-sns.svg';
// import amazon_sqs from '@assets/img/aws_services/amazon-sqs.svg';
// import amazon_vpc from '@assets/img/aws_services/amazon-vpc.svg';
// import api_gateway from '@assets/img/aws_services/api-gateway.svg';
// import app_sync from '@assets/img/aws_services/app-sync.svg';
// import doc_db from '@assets/img/aws_services/doc-db.svg';
// import aws_certificate_manager from '@assets/img/aws_services/aws-certificate-manager.svg';
// import aws_network from '@assets/img/aws_services/aws_network.svg';
// import aws_kinesis from '@assets/img/aws_services/aws-kinesis.svg';
// import aws_cloudformation from '@assets/img/aws_services/aws-cloudformation.svg';
// import aws_guardduty from '@assets/img/aws_services/aws-guardduty.svg';
// import aws_cloudtrail from '@assets/img/aws_services/aws-cloudtrail.svg';
// import aws_cloudwatch from '@assets/img/aws_services/aws-cloudwatch.svg';
// import aws_codebuild from '@assets/img/aws_services/aws-codebuild.svg';
import aws_config from '@assets/img/aws_services/aws-config.svg';
// import aws_dynamodb from '@assets/img/aws_services/aws-dynamodb.svg';
// import aws_elastic_beanstalk from '@assets/img/aws_services/aws-elastic-beanstalk.svg';
// import aws_emr from '@assets/img/aws_services/aws-emr.svg';
// import aws_opensearch from '@assets/img/aws_services/aws-opensearch.svg';
// import aws_kms from '@assets/img/aws_services/aws-kms.svg';
// import aws_dms from '@assets/img/aws_services/aws-dms.svg';
import aws_dax from '@assets/img/aws_services/aws-dax.svg';
// import aws_lambda from '@assets/img/aws_services/aws-lambda.svg';
// import aws_organizations from '@assets/img/aws_services/aws-organizations.svg';
// import aws_rds from '@assets/img/aws_services/aws-rds.svg';
// import aws_route53 from '@assets/img/aws_services/aws-route53.svg';
// import ec2_instances from '@assets/img/aws_services/ec2-instances.svg';
// import ECR from '@assets/img/aws_services/ECR.svg';
// import ECS from '@assets/img/aws_services/ECS.svg';
// import EFS from '@assets/img/aws_services/EFS.svg';
// import elastic_load_balancing from '@assets/img/aws_services/elastic-load-balancing.svg';
// import iam from '@assets/img/aws_services/iam.svg';
// import secrets_manager from '@assets/img/aws_services/secrets-manager.svg';
// import security_group from '@assets/img/aws_services/security-group.svg';
// import vpc_elastic_network_interface from '@assets/img/aws_services/vpc-elastic-network-interface.svg';
// import amazon_sfn from '@assets/img/aws_services/aws_step_functions.svg';
// import amazon_wfa from '@assets/img/aws_services/wfa.svg';
// import amazon_glue from '@assets/img/aws_services/aws-glue.svg';
// import aws_step_functions from '@assets/img/aws_services/aws_step_functions.svg';
// import athena from '@root/assets/img/aws_services/aws_athena.svg';
import CountTooltip from '@root/components/table/cell-types/CountTooltip';
import Tooltip from '@root/components/v2/ui-elements/Tooltip';
import Neptune from '@assets/img/aws_services/AWS_Neptune.svg';
import Ebs from '@assets/img/aws_services/AWS__EBS.svg';
import Account from '@assets/img/aws_services/AWS_Account.svg';
// import Backup from '@assets/img/aws_services/aws_backup_1.svg';
// import eks from '@assets/img/aws_services/aws_eks.svg';
// import aws_system_manager from '@assets/img/aws_services/aws-systems-manager.svg';
// import aws_fsx from '@assets/img/aws_services/aws-fsx.svg';
// import aws_events from '@assets/img/aws_services/aws-events.svg';
import aws_eventbridge from '@assets/img/aws_services/aws-eventbridge.svg';
// import aws_identity_center from '@assets/img/aws_services/aws-identity-center.png';
import cloud_dns from '@assets/img/gcp-service-icons/cloud_dns.svg';
import cloud_load_balancing from '@assets/img/gcp-service-icons/cloud_load_balancing.svg';
// import identity_and_access_management from '@assets/img/gcp-service-icons/identity_and_access_management.svg';
import gcp_iam from '@assets/img/gcp-service-icons/GCP.IAM.svg';
// import Cloud_key_management_service from '@assets/img/gcp-service-icons/key_management_service.svg';
import gcp_kms from '@assets/img/gcp-service-icons/GCP.KMS.svg';
// import compute_engine from '@assets/img/gcp-service-icons/compute_engine.svg';
import gcp_compute_engine from '@assets/img/gcp-service-icons/GCP.COMPUTE_ENGINE.svg';
import cloud_functions from '@assets/img/gcp-service-icons/cloud_functions.svg';
// import cloud_storage from '@assets/img/gcp-service-icons/cloud_storage.svg';
// import cloud_sql from '@assets/img/gcp-service-icons/cloud_sql.svg';
import gcp_cloud_sql from '@assets/img/gcp-service-icons/GCP.CLOUD_SQL.svg';
// import bigquery from '@assets/img/gcp-service-icons/bigquery.svg';
import gcp_big_query from '@assets/img/gcp-service-icons/GCP.BIG_QUERY.svg';
// import pubsub from '@assets/img/gcp-service-icons/pubsub.svg';
import gcp_pubsub from '@assets/img/gcp-service-icons/GCP.PUBSUB.svg';
// import cloud_logging from '@assets/img/gcp-service-icons/cloud_logging.svg';
import service_usage from '@assets/img/gcp-service-icons/service_discovery.svg';
import assetinventory from '@assets/img/gcp-service-icons/asset_inventory.svg';
import gcpvpc from '@assets/img/gcp-service-icons/virtual_private_cloud.svg';
// import dataproc from '@assets/img/gcp-service-icons/dataproc.svg';
import gcp_dataproc from '@assets/img/gcp-service-icons/GCP.DATAPROC.svg';
import { memo } from 'react';
import cognito from '@assets/img/aws_services/aws-cognito-logo.svg';
// import cloud_run from '@assets/img/gcp-service-icons/cloud_run.svg';
import gcp_cloud_run from '@assets/img/gcp-service-icons/GCP.CLOUD_RUN.svg';
import gcp_gke from '@assets/img/gcp-service-icons/gke_on-prem.svg';
import essential_contact from '@assets/img/gcp-service-icons/essential_contact.svg';
// import artifact_registry from '@assets/img/gcp-service-icons/artifact_registry.svg';
import gcp_artifact_registry from '@assets/img/gcp-service-icons/GCP.ARTIFACT_REGISTRY.svg';
// import google_kubernetes_engine from '@assets/img/gcp-service-icons/google_kubernetes_engine.svg';
import gcp_kubernetes_engine from '@assets/img/gcp-service-icons/GCP.KUBERNETES_ENGINE.svg';
// import gcp_lb from '@assets/img/gcp-service-icons/GCP_LB.png';
import gcp_lb from '@assets/img/gcp-service-icons/GCP.CLOUD_LOAD_BALANCING.svg';
// import cloud_monitoring from '@assets/img/gcp-service-icons/Cloud_Monitoring.svg';
import cloude_scheduler_rounded from '@assets/img/gcp-service-icons/Cloud_Scheduler_rounded.svg';
// import cloude_scheduler from '@assets/img/gcp-service-icons/Cloud_Scheduler.svg';
// import secret_manager from '@assets/img/gcp-service-icons/Secret_Manager.svg';
import secret_manager_rounded from '@assets/img/gcp-service-icons/Secret_manager_rounded.svg';
// import certificate_manager from '@assets/img/gcp-service-icons/Certificate_Manager.svg';
import certificate_manager_rounded from '@assets/img/gcp-service-icons/Certificate_manager_Rounded.svg';
// import cloude_armor from '@assets/img/gcp-service-icons/Cloud_Armor.svg';
import cloude_armor_rounded from '@assets/img/gcp-service-icons/Cloud_Scheduler_rounded.svg';
// import cloude_cdn from '@assets/img/gcp-service-icons/Cloud_CDN.svg';
import cloude_cdn_rounded from '@assets/img/gcp-service-icons/Cloud_CDN_rounded.svg';
// import cloude_composer from '@assets/img/gcp-service-icons/Cloud_Composer.svg';
import cloude_composer_rounded from '@assets/img/gcp-service-icons/Cloud_Composer_Rounded.svg';
import cloud_monitoring_rounded from '@assets/img/gcp-service-icons/Cloud_Monitoring_Rounded.svg';
import gcp_cf from '@assets/img/gcp-service-icons/GCP.CLOUD_FUNCTION.svg';
import gcp_cloud_storage from '@assets/img/gcp-service-icons/GCP.CLOUD_STORAGE.svg';
import gcp_cloud_logging from '@assets/img/gcp-service-icons/GCP.CLOUD_LOGGING.svg';
import gcp_event_arc from '@assets/img/gcp-service-icons/gcp-eventarc.png';
import gcp_workflow from '@assets/img/gcp-service-icons/gcp-workflow.png';
import gcp_cloud_deploy from '@assets/img/gcp-service-icons/gcp_cloud_deploy.png';
// Azure icons
import azure_active_directory from '@assets/img/azure_services/azure_active_directory.png';
import azure_app_service from '@assets/img/azure_services/azure_app_service.png';
import azure_backup_vault from '@assets/img/azure_services/azure_backup_vault.png';
import azure_cosmosDB from '@assets/img/azure_services/azure_cosmosDB.png';
import azure_db_for_postgresql from '@assets/img/azure_services/azure_db_for_postgresql.png';
import azure_elasticsan from '@assets/img/azure_services/azure_elasticsan.png';
import azure_keyvault from '@assets/img/azure_services/azure_keyvault.png';
import azure_mysqlDb from '@assets/img/azure_services/azure_mysqlDb.png';
import azure_network from '@assets/img/azure_services/azure_network.png';
import azure_rbac from '@assets/img/azure_services/azure_rbac.png';
import azure_recoveryvault from '@assets/img/azure_services/azure_recoveryvault.png';
import azure_rediscache from '@assets/img/azure_services/azure_rediscache.png';
import azure_security_center from '@assets/img/azure_services/azure_security_center.png';
import azure_sqlDB from '@assets/img/azure_services/azure_sqlDB.png';
import azure_storage_account from '@assets/img/azure_services/azure_storage_account.png';
import azure_virtual_machine from '@assets/img/azure_services/azure_virtual_machine.png';
import azure_monitor from '@assets/img/azure_services/azure_monitor.png';

// const IMAGE_MAP = {
//   account: Account,
//   ebs: Ebs,
//   backup: Backup,
//   neptune: Neptune,
//   accessanalyzer: access_analyzer,
//   acm: aws_certificate_manager,
//   apigateway: api_gateway,
//   api: api_gateway,
// cloudtrail: aws_cloudtrail,
//   autoscaling: auto_scaling,
//   ['auto scaling']: auto_scaling,
//   auto: auto_scaling,
//   beanstalk: aws_elastic_beanstalk,
//   elasticbeanstalk: aws_elastic_beanstalk,
//   cloudformation: aws_cloudformation,
//   cloudfront: amazon_cloudfront,
//   ec2: ec2_instances,
//   ['stepfunctions']: aws_step_functions,
//   ['step functions']: aws_step_functions,
//   config: aws_config,
//   cloudwatch: aws_cloudwatch,
//   dynamodb: aws_dynamodb,
//   ecr: ECR,
//   ecs: ECS,
//   efs: EFS,
//   elb: elastic_load_balancing,
//   lambda: aws_lambda,
//   elbv2: elastic_load_balancing,
//   elasticache: amazon_elasticcache,
//   emr: aws_emr,
//   iam: iam,
//   kms: aws_kms,
//   organization: aws_organizations,
//   organizations: aws_organizations,
//   route53: aws_route53,
//   route: aws_route53,
//   ['aws route 53']: aws_route53,
//   ['route 53']: aws_route53,
//   rds: aws_rds,
//   redshift: amazon_redshift,
//   vpc: amazon_vpc,
//   s3: amazon_s3,
//   ses: amazon_ses,
//   secretsmanager: secrets_manager,
//   secrets: secrets_manager,
//   sns: amazon_sns,
//   sqs: amazon_sqs,
//   sfn: amazon_sfn,
//   waf: amazon_wfa,
//   glue: amazon_glue,
//   wafv2: amazon_wfa,
//   ['aws access analyzer']: access_analyzer,
//   ['access analyzer']: access_analyzer,
//   ['athena']: athena,
//   ['aws eks']: eks,
//   eks: eks,
//   gcpclouddns: cloud_dns,
//   gcpdns: cloud_dns,
//   dns: cloud_dns,
//   gcpcloudloadbalancing: cloud_load_balancing,
//   gcploadbalancer: cloud_load_balancing,
//   balancer: cloud_load_balancing,
//   'gcpidentityandaccessmanagement(iam)': identity_and_access_management,
//   gcpiam: identity_and_access_management,
//   'gcpcloudkeymanagementservice(kms)': Cloud_key_management_service,
//   gcpkms: Cloud_key_management_service,
//   gcpcomputeengine: compute_engine,
//   engine: compute_engine,
//   gcpcloudfunctions: cloud_functions,
//   cloudfunctions: cloud_functions,
//   gcpcloudstorage: cloud_storage,
//   cloudstorage: cloud_storage,
//   gcpcloudlogging: cloud_logging,
//   cloudlogging: cloud_logging,
//   gcpcloudsql: cloud_sql,
//   cloudsql: cloud_sql,
//   ['gcpbigquery']: bigquery,
//   bigquery: bigquery,
//   'gcppub/sub': pubsub,
//   'pub/sub': pubsub,
//   gcpserviceusage: service_usage,
//   '(su)': service_usage,
//   'gcpserviceusage(su)': service_usage,
//   gcpfunctions: cloud_functions,
// functions: cloud_functions,
//   gcpstorage: cloud_storage,
//   storage: cloud_storage,
//   gcplogging: cloud_logging,
//   logging: cloud_logging,
//   gcpsql: cloud_sql,
//   sql: cloud_sql,
//   gcpassetinventory: assetinventory,
//   inventory: assetinventory,
//   gcpvpc: gcpvpc,
//   gcpdataproc: dataproc,
//   dataproc: dataproc,
//   gcpgke: gcp_gke,
//   gke: gcp_gke,
//   gcpessentialcontacts: essential_contact,
//   contacts: essential_contact,
//   cloudrun: cloud_run,
//   gcpcloudrun: cloud_run,
//   gcpartifactregistry: artifact_registry,
//   registry: artifact_registry,
//   cognito: cognito,
//   ['aws cognito']: cognito,
//   gcpkubernetesengine: google_kubernetes_engine,
// };

const IMAGE_BG_COLOR_MAP = {
  awsautoscaling: '#FF8FA3',
  ['auto scaling']: '#FF8FA3',
  auto: '#FF8FA3',
  autoscaling: '#FF8FA3',
  awsec2: '#FFB366',
  ec2: '#FFB366',
  awssystemsmanager: '#E88EBA',
  systemsmanager: '#E88EBA',
  awsssm: '#E88EBA',
  ssm: '#E88EBA',
  awsecs: '#FFC480',
  ecs: '#FFC480',
  eks: '#FFC480',
  ['aws eks']: '#FFC480',
  awseks: '#FFC480',
  awsredshift: '#8FA3FF',
  redshift: '#8FA3FF',
  awsbackup: '#A8D96E',
  backup: '#A8D96E',
  awsdirectconnect: '#C490FF',
  directconnect: '#C490FF',
  awssagemaker: '#5CD9B8',
  awsacm: '#FFAA99',
  acm: '#FFAA99',
  awsacmpca: '#FFAA99',
  acmpca: '#FFAA99',
  awsapigateway: '#FF8FA3',
  api: '#FF8FA3',
  awsbedrock: '#A8DDD1',
  bedrock: '#A8DDD1',
  awsapigatewayv2: '#FF8FA3',
  apigatewayv2: '#FF8FA3',
  apigateway: '#FF8FA3',
  awsappsync: '#E88EBA',
  appsync: '#E88EBA',
  awsdocdb: '#A690FF',
  docdb: '#A690FF',
  awsdocumentdb: '#A690FF',
  documentdb: '#A690FF',
  cloudtrail: '#E88EBA',
  awscloudtrail: '#E88EBA',
  awsnetworkfirewall: '#FFAA99',
  networkfirewall: '#FFAA99',
  awsnetwork: '#FFAA99',
  network: '#FFAA99',
  awscloudformation: '#E88EBA',
  cloudformation: '#E88EBA',
  awscloudfront: '#C490FF',
  cloudfront: '#C490FF',
  awskinesis: '#A690FF',
  kinesis: '#A690FF',
  awsstepfunctions: '#E88EBA',
  ['stepfunctions']: '#E88EBA',
  ['step functions']: '#E88EBA',
  awssfn: '#E88EBA',
  sfn: '#E88EBA',
  awscloudwatch: '#E88EBA',
  cloudwatch: '#E88EBA',
  awscodebuild: '#A690FF',
  codebuild: '#A690FF',
  awsopensearch: '#A690FF',
  opensearch: '#A690FF',
  awsdynamodb: '#A690FF',
  dynamodb: '#A690FF',
  awsecr: '#FFC480',
  ecr: '#FFC480',
  awsefs: '#A8D96E',
  efs: '#A8D96E',
  awselb: '#A690FF',
  elb: '#A690FF',
  awselb2: '#A690FF',
  elb2: '#A690FF',
  awselbv2: '#A690FF',
  elbv2: '#A690FF',
  awselasticache: '#8FA3FF',
  awslambda: '#FFB366',
  lambda: '#FFB366',
  awsemr: '#A690FF',
  emr: '#A690FF',
  awsiam: '#FF9EC2',
  iam: '#FF9EC2',
  awskms: '#FF9EC2',
  kms: '#FF9EC2',
  awsdms: '#8FA3FF',
  dms: '#8FA3FF',
  organization: '#E88EBA',
  awsorganizations: '#E88EBA',
  organizations: '#E88EBA',
  awsroute53: '#A690FF',
  route: '#A690FF',
  ['aws route 53']: '#A690FF',
  ['route 53']: '#A690FF',
  route53: '#A690FF',
  awsrds: '#E88EDD',
  rds: '#E88EDD',
  awsvpc: '#A690FF',
  vpc: '#A690FF',
  awss3: '#5CD9B8',
  awss3bucket: '#5CD9B8',
  s3bucket: '#5CD9B8',
  s3: '#5CD9B8',
  sns: '#FF8FA3',
  awssns: '#FF8FA3',
  awssecretsmanager: '#FFAA99',
  secretsmanager: '#FFAA99',
  secrets: '#FFAA99',
  awssqs: '#E88EBA',
  sqs: '#E88EBA',
  awswaf: '#FFAA99',
  awswafv2: '#FFAA99',
  waf: '#FFAA99',
  wafv2: '#FFAA99',
  ['athena']: '#A690FF',
  awsathena: '#A690FF',
  awscognito: '#FF8FA3',
  cognito: '#FF8FA3',
  ['aws cognito']: '#FF8FA3',
  gcpbigquery: '#D4A5D4',
  bigquery: '#D4A5D4',
  'gcpidentityandaccessmanagement(iam)': '#8FA3FF',
  gcpiam: '#8FA3FF',
  'gcpcloudkeymanagementservice(kms)': '#6FB8D9',
  gcpkms: '#6FB8D9',
  gcpcomputeengine: '#8FA3FF',
  computeengine: '#8FA3FF',
  gcpcloudfunctions: '#70D4D4',
  cloudfunctions: '#70D4D4',
  gcpfunctions: '#70D4D4',
  functions: '#70D4D4',
  gcpgcfv2: '#70D4D4',
  gcpgcfv1: '#70D4D4',
  gcpcloudstorage: '#B8D4F0',
  cloudstorage: '#B8D4F0',
  gcpstorage: '#B8D4F0',
  storage: '#B8D4F0',
  gcpsto: '#B8D4F0',
  gcpcloudlogging: '#D4B5F0',
  gcpgce: '#8FA3FF',
  cloudlogging: '#D4B5F0',
  gcplogging: '#D4B5F0',
  gcpvpc: '#D4B5F0',
  logging: '#D4B5F0',
  gcpcloudsql: '#B8D4F0',
  gcpsql: '#B8D4F0',
  sql: '#B8D4F0',
  gcpdataproc: '#8FA3FF',
  dataproc: '#8FA3FF',
  gcpcloudrun: '#8FA3FF',
  cloudrun: '#8FA3FF',
  gcpclr: '#8FA3FF',
  gcpartifactregistry: '#8FA3FF',
  gcpgar: '#8FA3FF',
  gcpcloudcdn: '#8FA3FF',
  cloudcdn: '#8FA3FF',
  artifactregistry: '#8FA3FF',
  'gcppub/sub': '#FFA8CC',
  'pub/sub': '#FFA8CC',
  gcpkubernetesengine: '#8FA3FF',
  kubernetesengine: '#8FA3FF',
  gcplb: '#6FB8D9',
  loadbalancer: '#6FB8D9',
  awsses: '#FF9EC2',
  ses: '#FF9EC2',
  awsglue: '#A690FF',
  glue: '#A690FF',
  awsidentitycenter: '#FF9EC2',
  identitycenter: '#FF9EC2',
  awsguardduty: '#FFAA99',
  guardduty: '#FFAA99',
  awsfsx: '#A8D96E',
  fsx: '#A8D96E',
  awsevents: '#A8D96E',
  events: '#A8D96E',
  awsbeanstalk: '#FFB366',
  elasticbeanstalk: '#FFB366',
  awselasticbeanstalk: '#FFB366',
  beanstalk: '#FFB366',
  // AWS services - using existing mappings where SVG is shared
  awsaccount: '#A8D96E', // New - Account service
  account: '#A8D96E',
  ebs: '#A8D96E', // Same as backup group
  awsebs: '#A8D96E',
  awsneptune: '#8FA3FF', // Neptune database
  neptune: '#8FA3FF',
  accessanalyzer: '#FFAA99', // Same color family as ACM
  awsaccessanalyzer: '#FFAA99',
  ['aws access analyzer']: '#FFAA99',
  ['access analyzer']: '#FFAA99',
  awseventbridge: '#FF9EC2', // Same as events
  eventbridge: '#FF9EC2',
  awsdax: '#A690FF', // DynamoDB related
  dax: '#A690FF',
  awsconfig: '#E88EBA', // Config service
  config: '#E88EBA',
  // GCP services - using existing mappings where possible
  gcpclouddns: '#A690FF', // DNS service
  clouddns: '#A690FF',
  gcpdns: '#A690FF',
  dns: '#A690FF',
  gcpcloudloadbalancing: '#6FB8D9', // Same as gcplb
  cloudloadbalancing: '#6FB8D9',
  gcploadbalancer: '#6FB8D9',
  balancer: '#6FB8D9',
  engine: '#8FA3FF', // Same as computeengine
  gcpeventarc: '#FFA8CC', // Event service - same family as pub/sub
  eventarc: '#FFA8CC',
  gcpworkflows: '#C490FF', // Workflow orchestration
  workflows: '#C490FF',
  gcpserviceusage: '#C490FF', // Service usage
  serviceusage: '#C490FF',
  'serviceusage(su)': '#C490FF',
  'gcpserviceusage(su)': '#C490FF',
  gcpassetinventory: '#8FA3FF', // Asset inventory
  inventory: '#8FA3FF',
  gcpgke: '#8FA3FF', // GKE - same as kubernetes
  gke: '#8FA3FF',
  gcpclouddeploy: '#8FA3FF', // Cloud Deploy
  clouddeploy: '#8FA3FF',
  gcpessentialcontacts: '#FFA8CC', // Contacts
  contacts: '#FFA8CC',
  registry: '#8FA3FF', // Same as gcpartifactregistry
  gcpcloudmonitoring: '#C490FF', // Cloud Monitoring
  cloudmonitoring: '#C490FF',
  gcpcloudschedulerr: '#C490FF', // Cloud Scheduler
  cloudschedulerr: '#C490FF',
  gcpcloudscheduler: '#C490FF',
  cloudscheduler: '#C490FF',
  gcpsecretmanager: '#FFA8CC', // Secret Manager
  secretmanager: '#FFA8CC',
  gcpcertificatemanager: '#FFA8CC', // Certificate Manager
  certificatemanager: '#FFA8CC',
  gcpcloudarmor: '#FFAA99', // Cloud Armor - security
  cloudarmor: '#FFAA99',
  gcpcloudcomposer: '#D4A5D4', // Cloud Composer
  cloudcomposer: '#D4A5D4',
};

const IMAGE_MAP = {
  awsaccount: Account,
  account: Account,
  ebs: Ebs,

  functions: cloud_functions,
  gcpgcfv2: gcp_cf,
  gcpgcfv1: gcp_cf,
  awsebs: Ebs,
  awsbackup: '/images/visualizer/service-icons/AWS_BACKUP.svg',
  awsneptune: Neptune,
  backup: '/images/visualizer/service-icons/AWS_BACKUP.svg',
  neptune: Neptune,
  accessanalyzer: access_analyzer,
  awsaccessanalyzer: access_analyzer,
  awsdirectconnect: '/images/visualizer/service-icons/AWS_DIRECTCONNECT.svg',
  directconnect: '/images/visualizer/service-icons/AWS_DIRECTCONNECT.svg',
  awssagemaker: '/images/visualizer/service-icons/AWS_SAGEMAKER.svg',
  sagemaker: '/images/visualizer/service-icons/AWS_SAGEMAKER.svg',
  awsacm: '/images/visualizer/service-icons/AWS_ACM.svg',
  acm: '/images/visualizer/service-icons/AWS_ACM.svg',
  awsacmpca: '/images/visualizer/service-icons/AWS_ACM.svg',
  acmpca: '/images/visualizer/service-icons/AWS_ACM.svg',
  awsapigateway: '/images/visualizer/service-icons/AWS_API_GATEWAY.svg',
  api: '/images/visualizer/service-icons/AWS_API_GATEWAY.svg',
  awsapigatewayv2: '/images/visualizer/service-icons/AWS_API_GATEWAY.svg',
  apigatewayv2: '/images/visualizer/service-icons/AWS_API_GATEWAY.svg',
  apigateway: '/images/visualizer/service-icons/AWS_API_GATEWAY.svg',
  awsappsync: '/images/visualizer/service-icons/AWS_APPSYNC.svg',
  appsync: '/images/visualizer/service-icons/AWS_APPSYNC.svg',
  awsdocdb: '/images/visualizer/service-icons/AWS_DOCUMENTDB.svg',
  cloudtrail: '/images/visualizer/service-icons/AWS_CLOUDTRAIL.svg',
  docdb: '/images/visualizer/service-icons/AWS_DOCUMENTDB.svg',
  awsdocumentdb: '/images/visualizer/service-icons/AWS_DOCUMENTDB.svg',
  documentdb: '/images/visualizer/service-icons/AWS_DOCUMENTDB.svg',
  awsnetworkfirewall: '/images/visualizer/service-icons/AWS_NETWORKFIREWALL.svg',
  networkfirewall: '/images/visualizer/service-icons/AWS_NETWORKFIREWALL.svg',
  awsnetwork: '/images/visualizer/service-icons/AWS_NETWORKFIREWALL.svg',
  network: '/images/visualizer/service-icons/AWS_NETWORKFIREWALL.svg',
  awscloudtrail: '/images/visualizer/service-icons/AWS_CLOUDTRAIL.svg',
  awsautoscaling: '/images/visualizer/service-icons/AWS_AUTO_SCALING.svg',
  autoscaling: '/images/visualizer/service-icons/AWS_AUTO_SCALING.svg',
  ['auto scaling']: '/images/visualizer/service-icons/AWS_AUTO_SCALING.svg',
  auto: '/images/visualizer/service-icons/AWS_AUTO_SCALING.svg',
  awsbeanstalk: '/images/visualizer/service-icons/AWS_Elastic_Beanstalk.svg',
  elasticbeanstalk: '/images/visualizer/service-icons/AWS_Elastic_Beanstalk.svg',
  awselasticbeanstalk: '/images/visualizer/service-icons/AWS_Elastic_Beanstalk.svg',
  beanstalk: '/images/visualizer/service-icons/AWS_Elastic_Beanstalk.svg',
  awscloudformation: '/images/visualizer/service-icons/AWS_CLOUDFORMATION.svg',
  awsbedrock: '/images/visualizer/service-icons/aws-bedrock.svg',
  bedrock: '/images/visualizer/service-icons/aws-bedrock.svg',
  cloudformation: '/images/visualizer/service-icons/AWS_CLOUDFORMATION.svg',
  awscloudfront: '/images/visualizer/service-icons/AWS_CLOUDFRONT.svg',
  cloudfront: '/images/visualizer/service-icons/AWS_CLOUDFRONT.svg',
  awsec2: '/images/visualizer/service-icons/AWS_EC2.svg',
  ec2: '/images/visualizer/service-icons/AWS_EC2.svg',
  awsevents: '/images/visualizer/service-icons/AWS_Events.svg',
  events: '/images/visualizer/service-icons/AWS_Events.svg',
  awsidentitycenter: '/images/visualizer/service-icons/AWS_Identity_Center.svg',
  identitycenter: '/images/visualizer/service-icons/AWS_Identity_Center.svg',
  awseventbridge: aws_eventbridge,
  eventbridge: aws_eventbridge,
  awsfsx: '/images/visualizer/service-icons/AWS_Fsx.svg',
  fsx: '/images/visualizer/service-icons/AWS_Fsx.svg',
  awssystemsmanager: '/images/visualizer/service-icons/SSM.svg',
  systemsmanager: '/images/visualizer/service-icons/SSM.svg',
  awsssm: '/images/visualizer/service-icons/SSM.svg',
  ssm: '/images/visualizer/service-icons/SSM.svg',
  awsdax: aws_dax,
  dax: aws_dax,
  awskinesis: '/images/visualizer/service-icons/AWS_KINESIS.svg',
  kinesis: '/images/visualizer/service-icons/AWS_KINESIS.svg',
  awsstepfunctions: '/images/visualizer/service-icons/AWS_STEPFUNCTION.svg',
  ['stepfunctions']: '/images/visualizer/service-icons/AWS_STEPFUNCTION.svg',
  ['step functions']: '/images/visualizer/service-icons/AWS_STEPFUNCTION.svg',
  awsconfig: aws_config,
  config: aws_config,
  awscloudwatch: '/images/visualizer/service-icons/AWS_CLOUDWATCH.svg',
  cloudwatch: '/images/visualizer/service-icons/AWS_CLOUDWATCH.svg',
  awscodebuild: '/images/visualizer/service-icons/AWS_CODEBUILD.svg',
  codebuild: '/images/visualizer/service-icons/AWS_CODEBUILD.svg',
  awsopensearch: '/images/visualizer/service-icons/AWS_OPENSEARCH.svg',
  opensearch: '/images/visualizer/service-icons/AWS_OPENSEARCH.svg',
  awsdynamodb: '/images/visualizer/service-icons/AWS_DOCUMENTDB.svg',
  dynamodb: '/images/visualizer/service-icons/AWS_DOCUMENTDB.svg',
  awsecr: '/images/visualizer/service-icons/AWS_ECR.svg',
  awsecs: '/images/visualizer/service-icons/AWS_ECS.svg',
  awsefs: '/images/visualizer/service-icons/AWS_EFS.svg',
  ecr: '/images/visualizer/service-icons/AWS_ECR.svg',
  ecs: '/images/visualizer/service-icons/AWS_ECS.svg',
  efs: '/images/visualizer/service-icons/AWS_EFS.svg',
  awselb2: '/images/visualizer/service-icons/AWS_ELB.svg',
  elb2: '/images/visualizer/service-icons/AWS_ELB.svg',
  awselb: '/images/visualizer/service-icons/AWS_ELB.svg',
  elb: '/images/visualizer/service-icons/AWS_ELB.svg',
  awslambda: '/images/visualizer/service-icons/AWS_LAMBDA.svg',
  lambda: '/images/visualizer/service-icons/AWS_LAMBDA.svg',
  awselbv2: '/images/visualizer/service-icons/AWS_ELB.svg',
  elbv2: '/images/visualizer/service-icons/AWS_ELB.svg',
  awselasticache: '/images/visualizer/service-icons/AWS_ELASTICACHE.svg',
  awsemr: '/images/visualizer/service-icons/AWS_EMR.svg',
  emr: '/images/visualizer/service-icons/AWS_EMR.svg',
  awsiam: '/images/visualizer/service-icons/AWS_IAM.svg',
  iam: '/images/visualizer/service-icons/AWS_IAM.svg',
  awskms: '/images/visualizer/service-icons/AWS_KMS.svg',
  kms: '/images/visualizer/service-icons/AWS_KMS.svg',
  awsdms: '/images/visualizer/service-icons/AWS_DMS.svg',
  dms: '/images/visualizer/service-icons/AWS_DMS.svg',
  awsguardduty: '/images/visualizer/service-icons/AWS_Guardduty.svg',
  guardduty: '/images/visualizer/service-icons/AWS_Guardduty.svg',
  organization: '/images/visualizer/service-icons/AWS_ORGANISATION.svg',
  awsorganizations: '/images/visualizer/service-icons/AWS_ORGANISATION.svg',
  organizations: '/images/visualizer/service-icons/AWS_ORGANISATION.svg',
  awsroute53: '/images/visualizer/service-icons/AWS_ROUTE53.svg',
  route: '/images/visualizer/service-icons/AWS_ROUTE53.svg',
  ['aws route 53']: '/images/visualizer/service-icons/AWS_ROUTE53.svg',
  ['route 53']: '/images/visualizer/service-icons/AWS_ROUTE53.svg',
  route53: '/images/visualizer/service-icons/AWS_ROUTE53.svg',
  awsrds: '/images/visualizer/service-icons/AWS_RDS.svg',
  rds: '/images/visualizer/service-icons/AWS_RDS.svg',
  awsredshift: '/images/visualizer/service-icons/AWS_REDSHIFT.svg',
  redshift: '/images/visualizer/service-icons/AWS_REDSHIFT.svg',
  awsvpc: '/images/visualizer/service-icons/AWS_VPC.svg',
  vpc: '/images/visualizer/service-icons/AWS_VPC.svg',
  awss3: '/images/visualizer/service-icons/AWS_S3.svg',
  awss3bucket: '/images/visualizer/service-icons/AWS_S3.svg',
  s3bucket: '/images/visualizer/service-icons/AWS_S3.svg',
  s3: '/images/visualizer/service-icons/AWS_S3.svg',
  awsses: '/images/visualizer/service-icons/AWS_SES.svg',
  ses: '/images/visualizer/service-icons/AWS_SES.svg',
  eks: '/images/visualizer/service-icons/AWS_EKS.svg',
  awssecretsmanager: '/images/visualizer/service-icons/AWS_SECRETSMANAGER.svg',
  secretsmanager: '/images/visualizer/service-icons/AWS_SECRETSMANAGER.svg',
  secrets: '/images/visualizer/service-icons/AWS_SECRETSMANAGER.svg',
  awssns: '/images/visualizer/service-icons/AWS_SNS.svg',
  awssqs: '/images/visualizer/service-icons/AWS_SQS.svg',
  awssfn: '/images/visualizer/service-icons/AWS_STEPFUNCTION.svg',
  awswaf: '/images/visualizer/service-icons/AWS_WAF.svg',
  awsglue: '/images/visualizer/resource-icons/AWS.Glue.svg',
  awswafv2: '/images/visualizer/service-icons/AWS_WAF.svg',
  sns: '/images/visualizer/service-icons/AWS_SNS.svg',
  sqs: '/images/visualizer/service-icons/AWS_SQS.svg',
  sfn: '/images/visualizer/service-icons/AWS_STEPFUNCTION.svg',
  waf: '/images/visualizer/service-icons/AWS_WAF.svg',
  glue: '/images/visualizer/resource-icons/AWS.Glue.svg',
  wafv2: '/images/visualizer/service-icons/AWS_WAF.svg',
  ['aws access analyzer']: access_analyzer,
  ['access analyzer']: access_analyzer,
  ['athena']: '/images/visualizer/service-icons/AWS_ATHENA.svg',
  ['aws eks']: '/images/visualizer/service-icons/AWS_EKS.svg',
  awsathena: '/images/visualizer/service-icons/AWS_ATHENA.svg',
  awseks: '/images/visualizer/service-icons/AWS_EKS.svg',
  gcpclouddns: cloud_dns,
  clouddns: cloud_dns,
  gcpdns: cloud_dns,
  dns: cloud_dns,
  gcpcloudloadbalancing: cloud_load_balancing,
  cloudloadbalancing: cloud_load_balancing,
  gcploadbalancer: cloud_load_balancing,
  balancer: cloud_load_balancing,
  'gcpidentityandaccessmanagement(iam)': gcp_iam,
  gcpiam: gcp_iam,
  'gcpcloudkeymanagementservice(kms)': gcp_kms,
  gcpkms: gcp_kms,
  gcpcomputeengine: gcp_compute_engine,
  gcpgce: gcp_compute_engine,
  computeengine: gcp_compute_engine,
  engine: gcp_compute_engine,
  gcpcloudfunctions: gcp_cf,
  cloudfunctions: gcp_cf,
  gcpcloudstorage: gcp_cloud_storage,
  cloudstorage: gcp_cloud_storage,
  // gcpsto : gcp_cloud_storage,
  gcpsto: gcp_cloud_storage,
  gcpcloudlogging: gcp_cloud_logging,
  cloudlogging: gcp_cloud_logging,
  gcpcloudsql: gcp_cloud_sql,
  cloudsql: gcp_cloud_sql,

  gcpeventarc: gcp_event_arc,
  eventarc: gcp_event_arc,
  gcpworkflows: gcp_workflow,
  workflows: gcp_workflow,
  // ['gcpbigquery']: gcp_big_query,
  gcpbigquery: gcp_big_query,
  bigquery: gcp_big_query,
  'gcppub/sub': gcp_pubsub,
  'pub/sub': gcp_pubsub,
  gcpserviceusage: service_usage,
  serviceusage: service_usage,
  'serviceusage(su)': service_usage,
  'gcpserviceusage(su)': service_usage,
  gcpfunctions: gcp_cf,
  // functions: gcp_cf,
  gcpstorage: gcp_cloud_storage,
  storage: gcp_cloud_storage,
  gcplogging: gcp_cloud_logging,
  logging: gcp_cloud_logging,
  gcpsql: gcp_cloud_sql,
  sql: gcp_cloud_sql,
  gcpassetinventory: assetinventory,
  inventory: assetinventory,
  gcpvpc: gcpvpc,
  gcpdataproc: gcp_dataproc,
  dataproc: gcp_dataproc,
  gcpgke: gcp_gke,
  gke: gcp_gke,
  gcpclouddeploy: gcp_cloud_deploy,
  clouddeploy: gcp_cloud_deploy,
  gcpessentialcontacts: essential_contact,
  contacts: essential_contact,
  cloudrun: gcp_cloud_run,
  gcpcloudrun: gcp_cloud_run,
  gcpclr: gcp_cloud_run,
  gcpgar: gcp_artifact_registry,
  gcpartifactregistry: gcp_artifact_registry,
  artifactregistry: gcp_artifact_registry,
  registry: gcp_artifact_registry,
  awscognito: cognito,
  cognito: cognito,
  ['aws cognito']: cognito,
  gcpkubernetesengine: gcp_kubernetes_engine,
  gcplb: gcp_lb,
  loadbalancer: gcp_lb,
  gcpcloudmonitoring: cloud_monitoring_rounded,
  cloudmonitoring: cloud_monitoring_rounded,
  gcpcloudschedulerr: cloude_scheduler_rounded,
  cloudschedulerr: cloude_scheduler_rounded,
  gcpcloudscheduler: cloude_scheduler_rounded,
  cloudscheduler: cloude_scheduler_rounded,
  gcpsecretmanager: secret_manager_rounded,
  secretmanager: secret_manager_rounded,
  gcpcertificatemanager: certificate_manager_rounded,
  certificatemanager: certificate_manager_rounded,
  gcpcloudarmor: cloude_armor_rounded,
  cloudarmor: cloude_armor_rounded,
  gcpcloudcdn: cloude_cdn_rounded,
  cloudcdn: cloude_cdn_rounded,
  gcpcloudcomposer: cloude_composer_rounded,
  cloudcomposer: cloude_composer_rounded,

  // Azure Icons
  azureactivedirectory: azure_active_directory,
  azureappservices: azure_app_service,
  azurenetwork: azure_network,
  azuresecuritycenter: azure_security_center,
  azurestorageaccounts: azure_storage_account,
  azurevirtualmachines: azure_virtual_machine,
  azuresqldatabase: azure_sqlDB,
  azurekeyvault: azure_keyvault,
  azurerbac: azure_rbac,
  azurebackupvault: azure_backup_vault,
  azurecosmosdb: azure_cosmosDB,
  azuremysqldatabase: azure_mysqlDb,
  azuredatabasemysql: azure_mysqlDb,
  azurerediscache: azure_rediscache,
  azurecacheredis: azure_rediscache,
  azurerecoveryservicesvault: azure_recoveryvault,
  azureelasticsan: azure_elasticsan,
  azuredatabaseforpostgressql: azure_db_for_postgresql,
  azuredatabasepostgressql: azure_db_for_postgresql,
  azurepostgresqldatabase: azure_db_for_postgresql,
  azuremonitor: azure_monitor,
};
const AWSServiceIcons = ({
  height = 20,
  width = 20,
  imgWidth = 28,
  imgHeight = 28,
  name,
  multiple,
  showName = true,
  tooltip = false,
  marginRight = 0,
}) => {
  // const serviceName = multiple ? name : name?.replace('gcp', '');
  const getImgName = serviceName => {
    if (!serviceName) return null;
    const formattedName = serviceName.toLowerCase().replace(/\s+/g, '').replace(/-/g, '');

    // console.log(formattedName, 'formattedName');
    return IMAGE_MAP[formattedName] || null;
  };

  const getImgBgColor = serviceName => {
    if (!serviceName) return null;
    const formattedName = serviceName.toLowerCase().replace(/\s+/g, '').replace(/-/g, '');

    // console.log(formattedName,"formattedName");
    return IMAGE_BG_COLOR_MAP[formattedName] || null;
  };

  if (multiple) {
    return (
      <>
        {name[0] && getImgName(name[0]) && (
          <Tooltip title={tooltip ? name[0] : ''} isIcon={true}>
            {getImgBgColor(name[0]) ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '30px',
                  backgroundColor: getImgBgColor(name[0]),
                  width: width,
                  height: height,
                  marginRight: marginRight ? marginRight : 0,
                }}>
                <img
                  src={getImgName(name[0])}
                  height={imgHeight}
                  width={imgWidth}
                  style={{ objectFit: 'contain' }}
                  alt={name[0]}
                />
              </div>
            ) : (
              <img
                src={getImgName(name[0])}
                height={height}
                width={width}
                style={{ objectFit: 'contain' }}
                alt={name}
              />
            )}
          </Tooltip>
        )}

        {showName && (
          <Tooltip title={name[0]}>
            <span
              className="SingleLine"
              style={{
                margin: '0 5px',
              }}>
              {name[0]}
            </span>
          </Tooltip>
        )}
        {name.length > 1 && (
          <CountTooltip
            // showFirst={false}
            labels={name}
            visibleLabelStyle={{ width: '140px !important' }}
            borderless
            showFirst={false}
          />
        )}
      </>
    );
  } else {
    // const imgName = IMAGE_MAP[name?.toLowerCase()] || null;
    const imgName = getImgName(name);
    // console.log(imgName, name, 'sdfsdfsdfsdfsdf');

    const imgBgColor = getImgBgColor(name);
    return (
      <>
        {imgName ? (
          tooltip ? (
            <Tooltip title={tooltip ? name : ''} isIcon={true}>
              {imgBgColor ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '30px',
                    backgroundColor: imgBgColor,
                    width: width,
                    height: height,
                    marginRight: marginRight ? marginRight : 0,
                  }}>
                  <img src={imgName} height={imgHeight} width={imgWidth} style={{ objectFit: 'contain' }} alt={name} />
                </div>
              ) : (
                <div
                  style={{
                    marginRight: marginRight ? marginRight : 0,
                  }}>
                  <img src={imgName} height={height} width={width} style={{ objectFit: 'contain' }} alt={name} />
                </div>
              )}
            </Tooltip>
          ) : imgBgColor ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '30px',
                backgroundColor: imgBgColor,
                width: width,
                height: height,
                marginRight: marginRight ? marginRight : 0,
              }}>
              <img src={imgName} height={imgHeight} width={imgWidth} style={{ objectFit: 'contain' }} alt={name} />
            </div>
          ) : (
            <div
              style={{
                marginRight: marginRight ? marginRight : 0,
              }}>
              <img src={imgName} height={height} width={width} style={{ objectFit: 'contain' }} alt={name} />
            </div>
          )
        ) : null}
      </>
    );
  }
};

// Whether a service name maps to an icon, for callers that need a fallback where AWSServiceIcons renders nothing.
export const hasServiceIcon = serviceName =>
  Boolean(serviceName && IMAGE_MAP[serviceName.toLowerCase().replace(/\s+/g, '').replace(/-/g, '')]);

export default memo(AWSServiceIcons);
